import api from "@/assets/js/utils/api.js";
import { showError } from "@/assets/js/utils/alertService";

export default {
  name: "OrderSuccess",
  data() {
    return {
      orderNumber: "", // 訂單編號
      orderDate: "", // 訂單成立日期
      orderStatus: "", // 訂單狀態
    };
  },
  async mounted() {
    await this.fetchOrderInfo();
  },

  methods: {
    // 🔥 從後端查詢訂單資訊
    async fetchOrderInfo() {
      // ➤ 從 URL Params 取得訂單編號
      const orderNo = this.$route.params.orderNo;

      this.orderNumber = orderNo; // 顯示在畫面

      try {
        // 呼叫後端 API
        const res = await api.get(`/front/order/info?orderNo=${orderNo}`);

        if (res.data?.success) {
          const data = res.data.data;

          this.orderDate = data.OrderDate || "未知";
          this.orderStatus = data.OrderStatus || "未知";
          

          console.log("訂單查詢成功：", data);
        } else {
          showError(res.data.message ?? "查詢訂單失敗");
        }
      } catch (err) {
        console.error("❌ 查詢訂單錯誤：", err);
        showError("系統異常，請稍後再試");
      }
    },

    // 🔄 繼續購物
    continueShopping() {
      this.$router.push("/products");
    },

    // 📦 查看訂單
    goToDashboard() {
      this.$router.push("/dashboard/orders");
    },
  },
};
